import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

export const openApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL
});

//###   AMBIENTE DESENVOLVIMENTO ###

// const api = axios.create({
//   baseURL: "/",
// });

// export const openApi = axios.create({
//   baseURL: "/",
// });

export default api;
